export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9340.650cf740.jpg";